<script>
// Bridge contract with the ClaudIA companion widget (React MF in claudia-app).
// These strings MUST match
// claudia-app/src/modules/companion-widget/companion-widget-events.ts
// (COMPANION_WIDGET_TOGGLE_EVENT / COMPANION_WIDGET_STATE_EVENT). Clicking the
// button toggles the widget; the widget echoes its open-state back so this
// button can reflect the active highlight.
const TOGGLE_EVENT = 'claudia:companion-widget:toggle';
const STATE_EVENT = 'claudia:companion-widget:state';

export default {
  name: 'CompanionWidgetButton',
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    window.addEventListener(STATE_EVENT, this.handleState);
  },
  beforeDestroy() {
    window.removeEventListener(STATE_EVENT, this.handleState);
  },
  methods: {
    handleState(event) {
      this.isOpen = !!event.detail?.open;
    },
    toggle() {
      window.dispatchEvent(new CustomEvent(TOGGLE_EVENT));
    },
  },
};
</script>

<template>
  <button
    v-tooltip.right="{
      content: $t('SIDEBAR.COMPANION_WIDGET'),
      classes: 'nav-rail-tooltip',
      boundariesElement: 'window',
    }"
    class="text-slate-700 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-gray-gray-2 dark:hover:bg-dark-dark-4 dark:hover:text-basic-primaryText hover:text-basic-primaryText relative"
    :class="{
      'bg-orange-light-4 dark:bg-orange-dark-4 text-basic-secondary hover:bg-orange-light-4 dark:hover:bg-orange-dark-4':
        isOpen,
    }"
    @click="toggle"
  >
    <fluent-icon-v2 icon="ia" :class="{ 'text-basic-secondary': isOpen }" />
    <span class="sr-only">{{ $t('SIDEBAR.COMPANION_WIDGET') }}</span>
  </button>
</template>
